export default __webpack_public_path__ + "static/media/ls.1b8ba620.svg";